import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { DetailsSection } from './components/DetailsSection';
import { FAQSection } from './components/FAQSection';
export function App() {
  useEffect(() => {
    document.title = 'Plan de 21 Días de Vitalidad Menopáusica | Método de Micro-Sincronización';
    let meta = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'description';
      document.head.appendChild(meta);
    }
    meta.content = 'Recupera tu energía matutina, elimina la neblina mental y vuelve a sentirte dueña de tu cuerpo en solo 21 días. Sin suplementos caros. Sin dietas extremas.';
    // og:title
    let ogTitle = document.querySelector('meta[property="og:title"]') as HTMLMetaElement;
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.content = 'Plan de 21 Días de Vitalidad Menopáusica';
    // og:description
    let ogDesc = document.querySelector('meta[property="og:description"]') as HTMLMetaElement;
    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    ogDesc.content = 'Recupera tu energía matutina, elimina la neblina mental y vuelve a sentirte dueña de tu cuerpo en solo 21 días';
  }, []);
  return <div className="min-h-screen bg-cream-light font-sans text-brown overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <SolutionSection data-id="element-3" />
      <DetailsSection data-id="element-4" />
      <FAQSection data-id="element-5" />

      <footer className="bg-brown text-cream-light py-12 text-center" data-id="element-6">
        <div className="max-w-5xl mx-auto px-6" data-id="element-7">
          <p className="text-cream-dark/60 text-sm mb-4" data-id="element-8">
            Este producto no sustituye el consejo médico profesional. Consulta a
            tu médico antes de realizar cambios en tu dieta o estilo de vida.
          </p>
          <p className="text-cream-dark/80" data-id="element-9">
            © {new Date().getFullYear()} Plan de Vitalidad Menopáusica. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}